module.exports = __webpack_public_path__ + "static/media/bottom_sahpe.7956348d.svg";